import React from 'react';
import HttpStatusPage from 'app/components/pages/HttpStatusPage';
import { useI18n } from 'app/components/localization';

export const BadRequest: React.FC = () => {
  const { t } = useI18n();
  return (
    <HttpStatusPage
      status={400}
      header={t('http-status-page.400.header')}
      message={t('http-status-page.400.message')}
    />
  );
};

export default BadRequest;
